module.exports = __webpack_public_path__ + "img/money5.7d235c0e.png";